import { Dispatch, connect } from 'react-redux';

import { AppState } from 'src';

import { VendorCreateComponent, VendorCreateComponentProperties } from './vendor-create.component';
import { clearVendorFull } from '../../../vendor.actions';

function mapStateToProps(state: AppState, ownProps: {}): Partial<VendorCreateComponentProperties> {
  return {};
}

function mapDispatchToProps(dispatch: Dispatch<AppState>, ownProps: {}): Partial<VendorCreateComponentProperties> {
  return {
    clearVendorFull: () => dispatch(clearVendorFull())
  };
}

export const VendorCreate = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorCreateComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/vendor-create/vendor-create.container.ts